import ContactRequests from './ContactRequests';

export default ContactRequests;


// WEBPACK FOOTER //
// ./src/components/modals/ContactRequestsModal/index.js